import { useLocation, useNavigate } from "@tanstack/react-router";
import { AlertCircle, Bug } from "lucide-react";
import { ROUTES } from "../config/constants";

interface ErrorIntegrationProps {
  /** HTTP status code (403, 500, etc.) */
  statusCode?: number;
  /** Error message to include in the ticket */
  errorMessage?: string;
}

/**
 * ErrorIntegration — shows "Créer un ticket ?" link when an error occurs.
 * Can be embedded in error boundaries or used standalone.
 *
 * Pre-fills ticket context with current route and error details.
 */
export function ErrorIntegration({ statusCode, errorMessage }: ErrorIntegrationProps) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleCreateTicket = () => {
    const params = new URLSearchParams();
    params.set("from", location.pathname);
    if (statusCode) params.set("error_status", String(statusCode));
    if (errorMessage) params.set("error_message", errorMessage);

    navigate({
      to: ROUTES.TICKETS.CREATE,
      search: {
        from: location.pathname,
        error_status: statusCode ? String(statusCode) : undefined,
        error_message: errorMessage || undefined,
      },
    });
  };

  return (
    <div className="flex items-center gap-2 mt-3 p-3 bg-base-200/50 rounded-lg border border-base-300/50">
      <Bug className="w-4 h-4 text-base-content/50 shrink-0" />
      <span className="text-sm text-base-content/70">Ce problème persiste ?</span>
      <button
        type="button"
        className="btn btn-ghost btn-xs text-primary gap-1"
        onClick={handleCreateTicket}
      >
        <Bug className="w-3 h-3" />
        Créer un ticket
      </button>
    </div>
  );
}
